import { SearchEntity } from "PFApp/components/search_autocomplete/search_autocomplete.types";
import { SearchInput } from "PFApp/components/search_input";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";
import React, { useState } from "react";

import { NamedResourceTable } from "./named_resource_table";
import { RowSelection } from "./reassign_content";
import css from "./reassign_content.module.scss";

export const ReassignContentNamedResources = ({ onTargetProfileChange, rowSelectionState }: RowSelection) => {
  const [namedResourcesSearchValue, setNamedResourcesSearchValue] = useState("");

  return (
    <>
      <SearchInput
        term={namedResourcesSearchValue}
        pageKey={RecentSearchesPageKey.ReassignProfile}
        onTermChange={(value: string) => setNamedResourcesSearchValue(value)}
        classes={{
          root: css.search
        }}
        autocompleteConfig={[{ entity: SearchEntity.Profile, useAsTerm: true, profileVisibility: "active" }]}
        fullWidth
      />
      <NamedResourceTable
        searchValue={namedResourcesSearchValue}
        onTargetProfileChange={onTargetProfileChange}
        rowSelectionState={rowSelectionState}
      />
    </>
  );
};
